import { WebFsError } from '#common/types';
class UnreachableError extends WebFsError {
    constructor() {
        super('Unreachable');
    }
}
export function unreachable() {
    throw new UnreachableError();
}
